import React, { useContext, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import queryString from 'query-string'
import { Formik, Form } from 'formik'
import SubHeader from '../../../../components/WithSubHeaderBG'
import CameraIcon from '../../../../components/Images/Camera'
import {
  Input,
  FloatingInput,
  Upload,
  DropDownSelect,
  CheckBox,
  OptionSelect,
  SearchableInput
} from '../../../../components/FormikInputs'
import Loader from '../../../../components/Loader'
import { getImageUrl } from '../../../../lib/utils/convertCanvasToImage'
import {
  FormContainer,
  StepHeader,
  FlexContainer,
  FlexChildLeft,
  FlexChildRight,
  FormActionDiv,
  ArrowRight,
  ImageUploadDiv,
  ThumbnailPlaceHolder,
  UpdateText,
  OverlayDiv,
  ThumbnailUpload,
  LoaderDiv,
  ContestLink,
  LabelContent
} from '../styles'
import { get, post ,put} from '../../../../lib/api'
import DependentDropDown from '../../../../components/FormikInputs/DropDownSelect/DropDown'
import { Box, Button, Text } from '../../../../designSystem'
import { menuItemObj } from '../../../../components/PrivatePage'
import { dateFormatter, checkOverseasUser, handlePageLoadEventLog, waitForSomeTime } from '../../../../lib/utils'
import NovelDescription from '../NovelDescriptionTips'
import DisabledNovelPopup from '../Details/disabledNovelPopup'
import { AccountContext } from '../../../../providers/accountProvider'
import { allLanguages } from '../../../Home/constants'
import AlertSnackBar from "../../../../components/AlertSnackBar";
import { Popup } from '../../../../components/Popup'
import { thankYouMessage } from '../../../../constants'
import AIGeneratedCoverImage from './AIGeneratedCoverImage'
import VerifyForBadPublish from '../ChapterAddEdit/PopupsInChapterAddEdit/VerifyForBadPublish'
import { handleNewEventLog } from '../../../../lib/utils/events'
import PostPublishScreen from '../ChapterAddEdit/PostPublishScreen'
// import { dummyContestList } from './mock'

const Link = styled.div`
  color: var(--azure-500);
  font-size: 12px; 
  display: inline-block;
  cursor: pointer;
`

const ContestBox = styled.div`
  margin-top: 16px;
  cursor:${({ contests }) => !contests && 'not-allowed'};
`

const ImageUploadComponent = ({ isLoading, imageUrl, placeholder, handleImageClick=()=>{}, removeUpdate }) => (
  <ImageUploadDiv onClick={handleImageClick}>
    {isLoading && <Loader size="md" />}
    {!isLoading && imageUrl && <ThumbnailUpload src={imageUrl} alt="" />}
    {!isLoading && !imageUrl && placeholder && (
      <ThumbnailPlaceHolder>
        {placeholder || 'Click here to upload or drag your file'}
      </ThumbnailPlaceHolder>
    )}
    { !isLoading && imageUrl && !removeUpdate && (
        <OverlayDiv>
          <CameraIcon />
          <UpdateText>
            Update Cover Image
          </UpdateText>
        </OverlayDiv>
      )
    }
  </ImageUploadDiv>
)

const DescriptionComponent = () => {
  const [description, toggleDescription] = useState(false)
  return(
    <>
      <Link onClick={() => toggleDescription(true)}>&nbsp;Learn more about great descriptions!</Link>
      {description && <NovelDescription onClose={() => toggleDescription(false)} />}
    </>
  )
}

export default function NovelForm(props) {
  const [book, setBook] = useState({})
  const [allContests,setContests] = useState([])
  const [contestOptionList,setContestOptionList] = useState([])
  const [contestDefaultValue, setContestDefaultValue] = useState('')
  const [alertText, setAlertText] = useState(false)
  const [showPopup, setShowPopup] = useState({show: false, message: ''})
  const [askForCoverImageFeedBack, setAskForCoverImageFeedBack] = useState(false)
  const [coverImageFeedback, SetCoverImageFeedback] = useState({feedback: '', message: ''})
  const [tropeInfo, updateTropeInfo] = useState('')
  const [verifyForBadPublish, setVerifyForBadPublish] = useState({ show : false});
  const [isLoading, setIsLoading] = useState(false)
  const [showPostPublishData, setPostPublishData] = useState(null)
  const [chapterDetails, setChapterDetails] = useState(null)
  const isMounted = useRef(false)
  const {action} = props.match.params
  const { first_publish } = props
  const { user, isUgcUser, isHindiUgcUser } = useContext(AccountContext)
  const supportEmail = (isUgcUser || isHindiUgcUser) ? 'writersupport@pocketfm.com' : 'writers@pocketfm.com'
  const isOverseasUser = checkOverseasUser(user)
  const bookLanguages = allLanguages
  const { proceed_to_chapter } = queryString.parse(props?.location?.search)
  const params = new URLSearchParams(props?.location?.search)

  const getBookLanguages = () => {
    if(user?.author_visibility === 'row'){
      return bookLanguages.filter(lang => lang.name === 'english')
    }
    if(user?.author_visibility === 'india' && isOverseasUser){
      return [
        {id: 1, name: 'hindi' },
        {id: 3, name: 'english'},
        {id: 3, name: 'tamil'},
        {id: 4, name: 'bengali'}]
    }
    return bookLanguages
  }

  const handleVerificationPopup = async (resp) => {   // this function allows to wait for the user's response in popup
    return new Promise((resolve, reject)=> {          
      setVerifyForBadPublish({
        show : true , 
        loading : false, 
        issue_type : resp?.issue,
        publish_anyway : resolve,
        review_again : resolve,
        words: resp?.problematic_words || [],
        message: resp?.message
      })
    })
  }

  const VerifyChapter = async (details) => {
    setVerifyForBadPublish({show : true , loading : true})  // open the popup to wait for verification and start loading
    try {
      let result = {message : 'Pending'}
      let maxApiCalls = 1
      while ((result?.message === 'Pending' || !result?.verified) && !isMounted.current && maxApiCalls < 11) {
        const resp = await post('/content_api/book.chapters/verify_chapter/?is_novel=1', {      // calling the verification for bad content api
          data : {
            uid: localStorage.getItem('uid'),
            book_id: props.match.params.id,
            chapter_id: details.chapter_id,
            latest_version: details.latest_version,
            file_url: details?.file_url,
            version_id: details.version_id,
            counter: maxApiCalls
          }
        })
        if (resp?.message !== 'Pending' && !resp?.verified){ 
          setVerifyForBadPublish({show : false , loading : false})
          return true
        }
        result = {...resp}
        if (result?.post_publish_data && result?.post_publish_data.length > 0) {
          details.from_incentive_value = result?.post_publish_data[0]?.from_incentive_value
          details.to_incentive_value = result?.post_publish_data[0]?.to_incentive_value
          details.rem_streak_days = result?.post_publish_data[0]?.rem_streak_days
        }
        await waitForSomeTime(1000)          // This function is to give time between api calls
        maxApiCalls+=1
      }
      if (result.verified && !result.issue_found) {
        setVerifyForBadPublish({show : false , loading : false})
        return true
      }
      else if (result.verified && result.issue_found) {                                  // if some issues are found
        const userPopupResponse = await handleVerificationPopup(result)
        if (userPopupResponse === 'review_again') {               // if response is review_again then only stop the flow
          return false 
        } else return true                          // else publish it by just changing the status
      }
      else if (maxApiCalls === 11){
        return true
      }
    } catch (error) {
      setVerifyForBadPublish({show : false , loading : false})
      console.log(error)
      return true  // even if the api fails for some reason we don't have to stop publishing chapter
    }
    return true;
  }

  useEffect(()=> {
    return () => {
      isMounted.current = true
    }
  }, [])

  useEffect(() => {
    let screenName = 'novel_detail_form'
    if(first_publish){
      screenName = 'novel_detail_form_first_publish'
    }

    handlePageLoadEventLog(screenName)
    setIsLoading(true)
    if (action === 'edit-novel-details') { 
      const params = {
        uid: localStorage.getItem('uid'),
        book_id: props.match.params.id,
        view: 'writers',
        is_novel: 1,
        req_author: 1
      }
      // get('EDIT_NOVELS_API', params)
      let novelDetail = {}
      get('/content_api/book.novel_details', { params })
        .then((response) => {
          // setBook(response.results);
          handleNewEventLog('novels_details','novels_novel_meta_details_screen_viewed',{route : window.location.pathname + window.location.search, module_name : 'novel_meta_data'}, user, response.results)
          delete response.results.tags
          const { trope_info, cover_image_feedback, cover_image_generated } = response.results
          if (cover_image_generated === "Yes" && !cover_image_feedback) setAskForCoverImageFeedBack(true)
          if (cover_image_feedback === 'Like') SetCoverImageFeedback({feedback: 'Like', message: ''})
          if (cover_image_feedback && cover_image_feedback !== 'Like') SetCoverImageFeedback({feedback: 'Dislike', message: cover_image_feedback})
          
            updateTropeInfo(trope_info?.map(item => item.tag_id).join(',') || '')
             // fetch tags data
             const tagsApi = '/content_api/tags.entity_tags'
             get(tagsApi, {
               params: {
                 entity_id: props.match.params.id,
                 is_novel: 1,
               }
             }).then(res => {
               const { result: tagsResult = [] } = res || {}
               const tags = tagsResult.map(({ tag_id }) => tag_id.trim()).join(',')
               response.results.tags = tags;
               setBook(response.results)
               novelDetail = response.results
               setIsLoading(false)
             }).catch(() => {
              setBook(response.results)
              setIsLoading(false)
             })

          get('/content_api/contest.list/', {
            params : {
              contest_type: 'novels_contest',
              language: isUgcUser || response.results?.is_novel === 2 ? 'english'  : user.languages || 'hindi',
              is_novel: 1,
              locale: isUgcUser || response.results?.is_novel === 2 ? 'US' : 'IN'
            }
          }).then((res) => {
            const list = []
            const optionList = []
            let selectedContest = {}
            const newresult  = [...res.result,];
            newresult.map((contest) => {
              if((new Date(response.results.create_time) - new Date(contest.starttime) >= 0) 
              && (new Date(contest.endtime) - new Date())>= 0  
              && (new Date() - new Date(contest.starttime)) >= 0
              && (!checkOverseasUser(user) || isUgcUser || response.results?.is_novel === 2)
               ){
                if(novelDetail?.contest_data?.is_disabled){
                  selectedContest = {id:'no_participate',name:`Don't want to participate in contest`}
                }
                else if(!novelDetail?.contest_data?.is_disabled && localStorage.getItem('contestId') && localStorage.getItem('contestId') === contest.contest_id){
                  const { book_id } = response.results;
                  const books = JSON.parse(localStorage.getItem('contestBooks')) || []
                  const index = books.findIndex((id) => id === book_id)
                  if(index >= 0){
                    selectedContest = contest
                  }
                }
                list.push(contest)
                optionList.push({id:contest.contest_id,name:contest.contest_title,type:contest?.extra_info?.category})
              }
            })
            if(list.length){
              optionList.push({id:'no_participate',name:`Don't want to participate in any contest`})
            }
            setContests(list)
            setContestDefaultValue(selectedContest)
            setContestOptionList(optionList)
          })
        })
        .catch((err) => {
          props.history.goBack()
          throw err
        })
    }
    
  }, [props.user])

  const updateTagsForMapping = (formData) => {
    const {tags} = formData
    let removedTags = ''
    if (book.tags) {
      const oldTags = book.tags.split(',')
      for (const tagIndex in oldTags) {
        if (!tags.includes(oldTags[tagIndex])) {
          if (removedTags !== '') removedTags = removedTags + ',' + oldTags[tagIndex]
          else removedTags += oldTags[tagIndex]
        }
      }
    }

    let dataForTagsMapping = {
      entity_id: formData.book_id,
      entity_type: 'book',
      tags,
      removed_tags: removedTags,
    }

    if(book?.is_novel === 2){
      const initialTropes = tropeInfo.split(',')
      const currentTropes = formData?.trope_info?.split(',')
      const removedTropes = []
      for (const trope of initialTropes) {
        if (!currentTropes?.includes(trope.trim())) {
          removedTropes.push(trope.trim());
        }
      }
      const showMoreDetails = {
        maturity_rating : formData?.maturity_rating,
        trope_id: formData?.show_troupe,
        removed_tropes: removedTropes?.join(',') || ''
      }
      dataForTagsMapping = {...dataForTagsMapping, ...showMoreDetails}
    }
    put(`/content_api/book.update_tags_entity_mapping?is_novel=${book?.is_novel || 1}`, {
      data: dataForTagsMapping,
    }).catch((err) => {
      props.history.goBack()
      throw err
    })
  }

  const contentChangeRequestEmailData = {
    subject: `Help to modify book details - <field name>`,
    body: `Platform: ${window.navigator.platform}
    Phone: ${user.phone_number}
    Email: ${user.email}
    Locale: ${user.location}
    UID: ${user.uid}
    Book Id: ${book.book_id}
    Book Name: ${book.book_title}
    Author Name: ${user.fullname}

    *************************

    Kindly share why you are trying to change your book details below 

    *************************`
  }

  const handleContentRestrictPopup = (field) => {
    if (book.content_editing && book?.restricted_fields?.includes(field)) {
      setShowPopup({
        show: true,
        message: (
          <>
            To modify the book details, please reach out to{' '}
            <a
              href={`mailto:${supportEmail}?subject=${encodeURI(
                contentChangeRequestEmailData.subject
              )}&body=${encodeURI(contentChangeRequestEmailData.body)}`}
              target="_blank"
              rel="noreferrer"
            >
              {supportEmail}
            </a>
            , to support for the same, along with reason for change.
          </>
        ),
      })
    }
  }

  const isThankYouMessageShown = ((book.status === 'approved' || book.status === 'published') && (user?.author_tier === 'platinum' || user?.author_tier === 'gold')) && 
  book?.application_status === 'ongoing'
  
  const handleAICoverImagePopup = () => {
    if (book?.cover_image_generated === 'No') {
      setShowPopup({
        show: true,
        message: book?.is_novel === 2 ? 'Once series details are updated / atleast 10 chapters are published, the cover image will be created & updated shortly.' : 'Once novel details are updated / atleast 5 chapters are published, the cover image will be created & updated shortly.',
      })
      return
    } 
    if (book?.cover_image_generated === 'Yes') {
      setShowPopup({
        show: true,
        message: <>Incase you want to request to change cover image, reach out to  <a href={`mailto:${supportEmail}?subject=${encodeURI(contentChangeRequestEmailData.subject)}&body=${encodeURI(contentChangeRequestEmailData.body)}`} target="_blank" rel="noreferrer">{supportEmail}</a> </>,
      })
      return
    } 
  }

  const handleSkip = () => {
    props.history.push(
      `${menuItemObj.novels}/add-chapter/${book.book_id}?redirect_to_novel=1`
    )
  }

  const showTroupeAndMaturityRating = book?.word_count >= 10000 && book.is_novel === 2

  const procced_to_publish = showTroupeAndMaturityRating && !book?.maturity_rating && !book?.trope_info.length

  return (
    <SubHeader
      title={
        action === 'edit-novel-details'
          ? 'Edit Novel Detail'
          : 'Create New Novel'
      }
      showBackButton
    >
      <Popup
        show={showPopup.show}
        close={() => setShowPopup({ show: false, message: '' })}
        renderActions={
          <>
            <button
              className="action-button"
              type="button"
              onClick={() => setShowPopup({ show: false, message: '' })}
            >
              Close
            </button>
          </>
        }
      >
        <Text variant="caption" lineHeight={1.8} fontWeight={500}>
          {showPopup.message}
        </Text>
      </Popup>
      <VerifyForBadPublish
        verifyForBadPublish={verifyForBadPublish}
        setVerifyForBadPublish={setVerifyForBadPublish}
      />
      {showPostPublishData && (
        <PostPublishScreen
          book={book}
          showPostPublishData={showPostPublishData}
          publishDate={chapterDetails?.create_time}
          flow="novelform"
        />
      )}

      {isLoading && <Loader />}
      {!isLoading && !showPostPublishData && (
        <Formik
          initialValues={{
            book_title: book?.book_title?.includes('Untitled Book')
              ? ''
              : book.book_title || '',
            language: proceed_to_chapter
              ? book.language || 'english'
              : book.language ||
                contestDefaultValue?.extra_info?.language ||
                '',
            book_type: (book.category_obj || {}).book_type || 'novel_series',
            description: book.description || '',
            description_en: book.description_en || '',
            category: (book.category_obj || {}).topic_id || '',
            sub_genre_id: (book.sub_genre_obj || {}).topic_id || '',
            tags: book.tags || '',
            image_url: book.image_url || '',
            created_by: book.created_by || '',
            show_state:
              book.status === 'approved'
                ? book.completed === 1
                  ? 'Completed'
                  : 'Running'
                : '',
            gender: book.gender_pref || '',
            contest: book.contest_data
              ? !book?.contest_data?.is_disabled ||
                book?.interested_in_contest === 'True'
                ? book.contest_data?.contest_id
                : 'no_participate'
              : book?.interested_in_contest === 'False'
              ? 'no_participate'
              : contestDefaultValue?.contest_id,
            copyright_declaration: book.declaration === 'True' ? true : false,
            sexual_content_declaration:
              book.declaration === 'True' ? true : false,
            non_consensual_sex_declaration:
              book.declaration === 'True' ? true : false,
            show_troupe: tropeInfo || '',
            maturity_rating: book.maturity_rating || '',
            thank_you_message:
              book.thank_you_message ||
              thankYouMessage[Math.floor(Math.random() * 15)],
          }}
          enableReinitialize
          validationSchema={Yup.object({
            book_title: Yup.string().trim().required('Required'),
            created_by: Yup.string(),
            language: Yup.string().required('Required'),
            book_type: Yup.string().required('Required'),
            category: Yup.string().required('Required'),
            sub_genre_id: Yup.string().required('Required'),
            tags: Yup.string().test(
              'len',
              'Max 5 tags allowed',
              (val) => !val || val?.split(',').length <= 5
            ),
            show_state: Yup.string(),
            gender: Yup.string(),
            description: Yup.string()
              .required('Required')
              .min(
                200,
                'Add min. 200-character & longer description to potentially boost audience engagement.'
              )
              .max(4000, 'You can add at max 4000 characters'),
            description_en: Yup.string()
              .min(
                200,
                'Add min. 200-character & longer description to potentially boost audience engagement.'
              )
              .max(4000, 'You can add at max 4000 characters'),
            copyright_declaration: Yup.bool().oneOf([true], 'Required'),
            sexual_content_declaration: Yup.bool().oneOf([true], 'Required'),
            non_consensual_sex_declaration: Yup.bool().oneOf(
              [true],
              'Required'
            ),
            show_troupe:
              showTroupeAndMaturityRating && Yup.string().required('Required'),
            maturity_rating:
              showTroupeAndMaturityRating && Yup.string().required('Required'),
            thank_you_message: Yup.string().max(
              50,
              'Input should not exceed 50 characters'
            ),
            contest: Yup.string().when(['language'], (language, schema) =>
              (isUgcUser || language === 'hindi' || language === 'tamil') &&
              allContests?.length > 0
                ? schema.required(['Required'])
                : schema
            ),
          })}
          onSubmit={async (values, { setSubmitting }) => {
            const formData = values
            handleNewEventLog(
              'novels_details',
              'novels_novel_meta_details_saved',
              {
                route: window.location.pathname + window.location.search,
                button: 'save_novel_meta_data',
              },
              user,
              book
            )
            if (formData.description.trim() === '') {
              setSubmitting(false)
              return
            }
            if (formData.language === 'english') {
              formData.description_en = book.description
            }

            formData.view = 'writers'
            if (action === 'edit-novel-details') {
              formData.book_id = book.book_id
              formData.created_by = book.created_by
              formData.gender_pref =
                values.gender.includes('male,female') ||
                values.gender.includes('female,male')
                  ? []
                  : values.gender
              formData.is_trial =
                book.status === 'approved' && values.show_state === 'Trial'
                  ? 1
                  : 0
              formData.completed =
                book.status === 'approved' && values.show_state === 'Completed'
                  ? 1
                  : 0
            } else {
              formData.created_by = localStorage.getItem('uid')
            }

            if (book?.contest_data) {
              formData.contest_data = {
                contest_id:
                  formData.contest === 'no_participate'
                    ? book?.contest_data?.contest_id
                    : formData.contest || book?.contest_data?.contest_id,
                entity_type: 'novel',
                is_disabled: formData.contest === 'no_participate' ? 1 : 0,
              }
              if (formData.contest === 'no_participate') {
                formData.interested_in_contest = false
              }
            } else if (formData.contest === 'no_participate') {
              formData.interested_in_contest = false
            } else if (formData.contest) {
              formData.contest_data = {
                contest_id: formData.contest,
                entity_type: 'novel',
                is_disabled: 0,
              }
              formData.interested_in_contest = true
            }

            if (
              isUgcUser
                ? formData?.language !== 'english'
                : !(
                    formData?.language === 'hindi' ||
                    formData?.language === 'tamil'
                  )
            ) {
              delete formData.contest_data
              delete formData?.interested_in_contest
            }
            if (!isThankYouMessageShown) {
              delete formData.thank_you_message
            }
            // return
            delete formData.contest
            delete formData.category
            updateTagsForMapping(formData)

            // cover Image Feedback
            if (!book?.cover_image_feedback) {
              const { feedback, message } = coverImageFeedback
              if (feedback) {
                if (coverImageFeedback.feedback === 'Like') {
                  formData.cover_image_feedback = feedback
                } else {
                  formData.cover_image_feedback = message
                    ? `Disliked it - ${message}`
                    : 'Disliked it'
                }
              }
            }
            try {
              const res = await post(
                `/content_api/book.create_book?is_novel=${
                  book?.is_novel || 1
                }`,
                {
                  data: formData,
                }
              )
              if (book?.is_novel === 2) {
                const {
                  sub_genre_id,
                  description_en,
                  tags,
                  show_state,
                  show_troupe,
                  maturity_rating,
                  description,
                } = formData
                let showData = {
                  created_by: book.created_by,
                  show_id: book?.show_id,
                  sub_genre_id,
                  show_desc_en: description_en,
                  tags,
                  show_state,
                  data_source: 'writers',
                  show_desc: description,
                  is_ugc: 1,
                }
                if (showTroupeAndMaturityRating) {
                  showData = { ...showData, show_troupe, maturity_rating }
                }
                await post(`/content_api/show.create?is_novel=0`, {
                  data: showData,
                }).then(() => {})
              }
              if (proceed_to_chapter) {
                props.history.push(
                  `${menuItemObj.novels}/add-chapter/${res.results.book_id}?redirect_to_novel=1`
                )
              }
              // else if (props.afterSubmit) {         // Removed this flow
              //   props.afterSubmit()
              // }
              else {
                // if first chapter publish and verification needed
                const chp_id = params.get('publish_chapter_id')
                if (chp_id) {
                  const chap_details = await get(
                    '/content_api/book.get_chapter_details',
                    {
                      params: {
                        chapter_id: params.get('publish_chapter_id'),
                        book_id: props.match.params.id,
                        view: 'writers',
                        is_novel: 1,
                      },
                    }
                  )
                  setChapterDetails(chap_details)
                  await put(
                    '/content_api/book.update_chapter_status?is_novel=1',
                    {
                      data: {
                        chapter_id: params.get('publish_chapter_id'),
                        status: 'review',
                        book_id: props.match.params.id,
                        view: 'writers',
                      },
                    }
                  )
                  const isChapterSafe = await VerifyChapter(chap_details.result)
                  if (!isChapterSafe) {
                    window.location.href = `${window.location.origin}${menuItemObj.novels}/edit-chapter/${props.match.params.id}?chapter_id=${chp_id}`
                    return
                  }
                  if (chap_details?.result?.from_incentive_value) {
                    setPostPublishData({
                      ...chap_details.result,
                    })
                    return
                  }
                }
                props.history.push(
                  `${menuItemObj.novels}/id/${res.results.book_id}?tab=published`
                )
              }
            } catch (err) {
              props.history.goBack()
              throw err
            }
          }}
        >
          {({
            values = {},
            isValid,
            isSubmitting,
            submitCount,
            errors,
            touched,
          }) => (
            <Form autoComplete="off">
              <FormContainer>
                <StepHeader>
                  {book?.is_novel === 2 ? '🎧 Series' : 'Novel'} Details
                  {proceed_to_chapter && (
                    <span onClick={() => handleSkip()}>Skip</span>
                  )}
                </StepHeader>
                <Box variant="hr" my={16} />
                <FlexContainer>
                  <FlexChildLeft fullWidth={book?.is_novel === 2}>
                    {book?.is_novel !== 2 && (
                      <Box
                        mt={[16, 0]}
                        onFocus={() => handleContentRestrictPopup('book_title')}
                      >
                        <FloatingInput
                          label="Title"
                          name="book_title"
                          type="text"
                          hasError={errors.book_title}
                          touched={touched.book_title}
                          showValidation
                          placeholder="Example - Kitni Mohabatt hai - कितनी मोहबत्त है"
                          infoTitle="Title of the novel"
                          maxLength="70"
                          readOnly={proceed_to_chapter || book?.is_novel === 2}
                        />
                      </Box>
                    )}
                    {book?.is_novel !== 2 && (
                      <Box
                        mt={16}
                        cursor={allContests.length === 0 && 'not-allowed'}
                        onClick={() => handleContentRestrictPopup('language')}
                      >
                        <DropDownSelect
                          label="Language"
                          name="language"
                          selectByName
                          infoTitle="Add the language of this novel"
                          placeholder="Select a Language"
                          hasError={errors.language}
                          showValidation
                          selectOptions={getBookLanguages()}
                          idKey="id"
                          nameKey="name"
                          readOnly={proceed_to_chapter || book?.is_novel === 2}
                        />
                      </Box>
                    )}

                    {/* As we now only checking if language is hindi then showing contest dropdown.
                      Once with different language for contest is live will change Dropdown to DependentDropdown
                      as Api will also change according to langugae , it will give response . */}
                    {allContests.length !== 0 &&
                      ((isUgcUser
                        ? values.language === 'english'
                        : values.language === 'hindi' ||
                          values.language === 'tamil') ||
                        values.language === '') && (
                        <ContestBox contests={allContests.length > 0}>
                          <DropDownSelect
                            label="Contest"
                            name="contest"
                            placeholder={
                              contestOptionList.length === 0
                                ? 'No Contest is live'
                                : 'Select a Contest'
                            }
                            selectOptions={contestOptionList}
                            idKey="id"
                            hasError={errors.contest}
                            nameKey="name"
                          />
                        </ContestBox>
                      )}
                    {/* {allContests.length == 0 && <ContestMessage>Novel is created before any contest started or No Contest is live</ContestMessage>} */}
                    {values.contest &&
                      (values.language === 'hindi' ||
                        values.language === 'tamil' ||
                        values.language === '') &&
                      allContests.map((contest) => {
                        const ContestEndDate = dateFormatter(contest.endtime)
                        const stage1Date = dateFormatter(
                          contest.extra_info?.end_date
                        )
                        const stage2Date = dateFormatter(
                          contest.extra_info?.stage2?.end_date
                        )
                        return (
                          contest.contest_id === values.contest && (
                            <p>
                              Note! the conditions to join this contest!
                              <br />
                              It should be a <b>fiction</b> series & follow
                              theme if applicable.
                              <br />
                              {contest.extra_info.category && (
                                <>
                                  Category: {contest.extra_info.category}
                                  <br />
                                </>
                              )}
                              Language: &quot;{contest.extra_info.language}
                              &quot;
                              <br />
                              Min words of{' '}
                              {parseInt(contest.extra_info?.min_words, 10) /
                                1000}
                              k written by{' '}
                              {contest.extra_info?.end_date
                                ? stage1Date
                                : ContestEndDate}
                              {contest.extra_info?.stage2
                                ? ' for Stage 1 '
                                : ''}
                              {contest.extra_info?.stage2?.min_words ? (
                                <>
                                  {' '}
                                  &amp; min{' '}
                                  {parseInt(
                                    contest.extra_info?.stage2?.min_words,
                                    10
                                  ) / 1000}
                                  k words by {stage2Date} for Stage 2
                                </>
                              ) : null}
                              <br />
                              <ContestLink
                                target={
                                  !window.localStorage.getItem('app_origin') &&
                                  '_blank'
                                }
                                href={contest?.content_url}
                              >
                                Click here for more details
                              </ContestLink>
                            </p>
                          )
                        )
                      })}
                    <Box
                      mt={16}
                      onClick={() => handleContentRestrictPopup('category')}
                    >
                      <DependentDropDown
                        label="Category"
                        name="category"
                        api="/content_api/topic.get_child_topics"
                        transformResponse={(response) =>
                          response.result.length > 0
                            ? response.result[0].sub_topics
                            : []
                        }
                        params={{
                          language: values.language.toLowerCase(),
                          is_novel: 1,
                          topic_type: 'novel_series',
                        }}
                        dependentOn="novel_series"
                        infoTitle="Select the category of this novel"
                        placeholder="Choose a Category"
                        hasError={submitCount > 0 && errors.category}
                        showValidation
                        language={values.language}
                        is_novel={1}
                        idKey="topic_id"
                        nameKey="topic_name"
                        tooltip={{
                          title: !values.book_type
                            ? 'Please select a type first'
                            : '',
                          placement: 'top',
                        }}
                      />
                    </Box>
                    <Box
                      mt={16}
                      onClick={() =>
                        handleContentRestrictPopup('sub_genre_obj')
                      }
                    >
                      <DependentDropDown
                        label="Sub Genre"
                        name="sub_genre_id"
                        api="/content_api/get_show_sub_genre_list"
                        transformResponse={(response) =>
                          response.result.length > 0 ? response.result : []
                        }
                        params={{
                          genre_topic_id: values.category,
                        }}
                        dependentOn={values.category}
                        infoTitle="Select the Sub Genre of this novel"
                        placeholder="Choose a Sub Genre"
                        hasError={submitCount > 0 && errors.sub_genre_id}
                        showValidation
                        // selectedContest={contestOptionList.find(contest => contest.contest_id === values['contest'])}
                        language={values.language}
                        is_novel={1}
                        idKey="topic_id"
                        nameKey="topic_name"
                        tooltip={{
                          title: !values.book_type
                            ? 'Please select a type first'
                            : '',
                          placement: 'top',
                        }}
                      />
                    </Box>
                    {+props?.first_publish !== 1 && (
                      <Box
                        mt={16}
                        onFocus={() => handleContentRestrictPopup('tags')}
                      >
                        <SearchableInput
                          label="Tags"
                          name="tags"
                          selectKey="tag_id"
                          nameKey="tag_name"
                          hasError={errors.tags}
                          openOnClick
                          showValidation
                          infoTitle="You can select maximum 5 tags"
                          placeholder="Select Tags"
                          apiUrl={
                            values.category
                              ? `/content_api/tag.get_topic_tags?topic_id=${values.category}`
                              : null
                          }
                          tooltip={{
                            title: !values.category
                              ? 'Please select novel category first'
                              : '',
                            direction: 'top',
                          }}
                        />
                      </Box>
                    )}
                  </FlexChildLeft>
                  <FlexChildRight>
                    {/* UGC user or Indian hindi book flow */}
                    {(isUgcUser ||
                      (!isUgcUser && book.language === 'hindi')) && (
                      <>
                        {book.cover_image_generated === 'No' && (
                          <ImageUploadComponent
                            imageUrl={book.image_url}
                            handleImageClick={handleAICoverImagePopup}
                            removeUpdate
                          />
                        )}
                        {book.cover_image_generated === 'Yes' && (
                          <AIGeneratedCoverImage
                            imageUrl={book.image_url}
                            handleImageClick={handleAICoverImagePopup}
                            askForCoverImageFeedBack={askForCoverImageFeedBack}
                            coverImageFeedback={coverImageFeedback}
                            SetCoverImageFeedback={SetCoverImageFeedback}
                            bookTitle={book.book_title}
                          />
                        )}
                      </>
                    )}
                    {/* Not UGC user and Not Indian hindi book flow */}
                    <Box>
                      {!isUgcUser &&
                        !(!isUgcUser && book.language === 'hindi') && (
                          <>
                            {book.content_editing &&
                              book?.restricted_fields?.includes(
                                'cover_img'
                              ) && (
                                <ImageUploadComponent
                                  imageUrl={values.image_url}
                                  handleImageClick={() =>
                                    handleContentRestrictPopup('cover_img')
                                  }
                                  removeUpdate
                                />
                              )}
                            {!(
                              book.content_editing &&
                              book?.restricted_fields?.includes('cover_img')
                            ) &&
                              !(first_publish && window.screen.width < 600) && (
                                <Upload
                                  name="image_url"
                                  placeholder="Upload a Thumbnail"
                                  renderComp={ImageUploadComponent}
                                  dimensionErrorMsg="The image does not follow the dimensions of the thumbnail. Please try with a different image."
                                  fileTypeTags="image"
                                  imageValidator={(width, height) =>
                                    width < height
                                  }
                                  potraitMode
                                  extraParams={{
                                    title: values.book_title || 'general',
                                  }}
                                  allowImageCrop
                                  aspectRatio={2 / 3}
                                  bookImg
                                  imageUrl={values.image_url}
                                  bookTitle={values.book_title}
                                  getImageUrl={() =>
                                    getImageUrl(
                                      values.book_title,
                                      user?.fullname
                                    )
                                  }
                                  removeInput={book?.restricted_fields?.includes(
                                    'cover_img'
                                  )}
                                />
                              )}
                          </>
                        )}
                    </Box>
                  </FlexChildRight>
                </FlexContainer>
                {showTroupeAndMaturityRating && (
                  <Box mt={16}>
                    <SearchableInput
                      // setPreviousValue={setPreviousTroupe}
                      allowMultiple={false}
                      label="Troupe"
                      name="show_troupe"
                      selectKey="tag_id"
                      hasError={errors.show_troupe}
                      nameKey="tag_name"
                      placeholder="Select Troupe"
                      apiUrl={`/content_api/get_trope_list?language=${values.language}`}
                      tooltip={{
                        title: !values.book_title
                          ? 'Please have a book title'
                          : '',
                        placement: 'top',
                      }}
                    />
                  </Box>
                )}
                {showTroupeAndMaturityRating && (
                  <OptionSelect
                    label="Maturity Rating"
                    name="maturity_rating"
                    hasError={submitCount > 0 && errors.maturity_rating}
                    selectKey="name"
                    infoTitle="Select the maturity rating of this audiobook"
                    allowDeSelect
                    selectOptions={[
                      { id: 1, label: 'Everyone', name: 'everyone' },
                      { id: 2, label: 'Ages 7+', name: 'seven_plus' },
                      { id: 3, label: 'Ages 13+', name: 'thirteen_plus' },
                      { id: 4, label: 'Ages 16+', name: 'sixteen_plus' },
                      { id: 5, label: 'Ages 18+', name: 'eighteen_plus' },
                    ]}
                  />
                )}
                {isThankYouMessageShown && (
                  <Box>
                    <Input
                      asTextArea
                      infoTitle="Thank you message"
                      label="Thank you message"
                      name="thank_you_message"
                      placeholder="Write a Thank you message regarding this novel"
                    />
                  </Box>
                )}
                <Box onFocus={() => handleContentRestrictPopup('description')}>
                  <Input
                    asTextArea
                    infoTitle="Description in language selected is required"
                    label={
                      values.language
                        ? `Description in ${values.language}`
                        : 'Description'
                    }
                    name="description"
                    rowCount={
                      values.language === 'hindi' && window.screen.width < 600
                        ? 10
                        : 5
                    }
                    hasError={errors.description}
                    showValidation
                    placeholder={
                      values.language !== 'hindi'
                        ? 'Write a description regarding this novel'
                        : 'Write a description regarding this novel. Sample Description : \n"कहते हैं कि आग और पानी एक दूसरे के वजूद को मिटा देते हैं। रिशान, एक गैंगस्टर है तो वहीं विधा एक एनजीओ मे काम करने वाली बेहद खुशमिजाज लड़की है। क्या होगा जब दोनों होंगे आमने-सामने? क्या इनके बीच पनपेगा प्यार या तकरार? क्या होगी इस इश्क की कहानी? पढ़े पूरी कहानी सिर्फ Pocket FM पर। "'
                    }
                  />
                </Box>
                {values.language === 'hindi' && <DescriptionComponent />}
                {!first_publish && values.language !== 'english' && (
                  <Box
                    onFocus={() => handleContentRestrictPopup('description_en')}
                  >
                    <Input
                      asTextArea
                      infoTitle="Description in English"
                      label="Description in English"
                      name="description_en"
                      placeholder="Write a description in english regarding this novel"
                    />
                  </Box>
                )}
                {action === 'edit-novel-details' &&
                  +props?.first_publish !== 1 && (
                    <OptionSelect
                      label={
                        book?.is_novel === 2 ? 'Series State' : 'Novel State'
                      }
                      name="show_state"
                      selectKey="name"
                      infoTitle="Select the state of this novel"
                      selectOptions={[
                        {
                          id: 1,
                          name: 'Running',
                        },
                        {
                          id: 2,
                          name: 'Completed',
                        },
                      ]}
                    />
                  )}
                <Box
                  variant="normal"
                  mt="24px"
                  mb="6px"
                  py={14}
                  px={14}
                  bg="var(--Grey300)"
                >
                  <LabelContent>Content Declaration</LabelContent>
                  <CheckBox
                    name="copyright_declaration"
                    msgTxt="You are the sole owner of the copyright of the work and is this an original work of fiction."
                    hasError={errors.copyright_declaration}
                  />
                  <CheckBox
                    name="sexual_content_declaration"
                    msgTxt="The book does NOT contain any sexual content featuring characters under the age of 18."
                    hasError={errors.sexual_content_declaration}
                  />
                  <CheckBox
                    name="non_consensual_sex_declaration"
                    msgTxt="The book does NOT contain non-consensual sex."
                    hasError={errors.non_consensual_sex_declaration}
                  />
                </Box>
                {(errors.copyright_declaration ||
                  errors.sexual_content_declaration ||
                  errors.non_consensual_sex_declaration) && (
                  <div style={{ color: 'red' }}>
                    Please do the content declaration
                  </div>
                )}
                <Box variant="hr" my="24px" />
                <FormActionDiv>
                  {!isSubmitting && (
                    <Button
                      style={{ opacity: !isValid ? 0.4 : 1 }}
                      variant="fillPrimary"
                      width={['100%', 'unset']}
                      rightIcon={<ArrowRight />}
                      type="submit"
                    >
                      {action === 'edit-novel-details'
                        ? proceed_to_chapter
                          ? 'Save & Go to First Chapter'
                          : procced_to_publish
                          ? 'Save and Publish'
                          : 'Save '
                        : 'Continue'}
                    </Button>
                  )}
                  {isSubmitting && (
                    <LoaderDiv>
                      <Loader size="md" />
                    </LoaderDiv>
                  )}
                </FormActionDiv>
                {alertText && (
                  <AlertSnackBar
                    closeBtn
                    text="Please fill all the required details."
                    close={() => setAlertText(false)}
                  />
                )}
              </FormContainer>
              {!!book.is_disabled && (
                <DisabledNovelPopup bookId={book.book_id} />
              )}
            </Form>
          )}
        </Formik>
      )}
    </SubHeader>
  )
}
